import Modal from "../../../components/Modal/Modal";

const VersionModal = ({ open, close, value, setValue, create }) => (
  <Modal open={open} close={close}>
    <h2>Yeni Sürüm Ekle</h2>
    <input
      className="modal-input"
      placeholder="Sürüm İsmi"
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
    <div className="modal-buttons">
      <button
        className="modal-add-button"
        onClick={() => {
          create(value);
          close();
        }}
      >
        Ekle
      </button>
      <button className="modal-close-button" onClick={close}>
        Kapat
      </button>
    </div>
  </Modal>
);
export default VersionModal;
